var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.68,
    height: 15.979,
    viewBox: "0 0 20.68 15.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-lg",
    transform: "translate(-5.641 -7.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2593",
    "data-name": "Raggruppa 2593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3466",
    "data-name": "Tracciato 3466",
    d: "M23.944,7.464a1.378,1.378,0,0,1,1.968,0,1.42,1.42,0,0,1,.019,1.974L14.814,22.579a1.378,1.378,0,0,1-2,.038L6.048,15.762a1.423,1.423,0,0,1,0-1.993,1.378,1.378,0,0,1,1.968,0l5.738,5.815L23.906,7.5a.465.465,0,0,1,.038-.041Z",
    fill: "#399138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.76170d92b3cc11bbe73c676274cecdfb.svg";
export { ForwardRef as ReactComponent };